export const freeTrialHeaderStyles = {
  fontFamily: "Lato",
  fontSize: "20px",
  fontWeight: "600",
  color: "#FF5E23",
  lineHeight: "32px",
};

export const freeTrialDescriptionStyles = {
  fontFamily: "Lato",
  fontSize: "14px",
  fontWeight: "600",
  color: "white",
  width: "200px",
};

export const subscriptionAmountStyles = {
  fontFamily: "Lato",
  marginTop: "8px",
  fontSize: "14px",
  fontWeight: "600",
  color: "#FF5E23",
};
